import type { FilterDef, FilterValues } from "@/lib/table"

import {
  ROLE_OPTIONS,
  type ConsoleRole,
  type KeyFilters,
  type UserFilters,
} from "./users-keys-data"

export function buildUserFilterSchema(): FilterDef[] {
  return [
    {
      id: "role",
      label: "Role",
      kind: "select",
      options: ROLE_OPTIONS.map((r) => ({ value: r.value, label: r.label })),
      placeholder: "Any role",
    },
    {
      id: "activity",
      label: "Activity",
      kind: "select",
      options: [
        { value: "signed-in", label: "Has signed in" },
        { value: "never", label: "Never signed in" },
      ],
      placeholder: "Any",
    },
  ]
}

export function userFiltersToQuery(values: FilterValues): UserFilters {
  const q: UserFilters = {}
  if (typeof values.role === "string" && ROLE_OPTIONS.some((r) => r.value === values.role)) {
    q.role = values.role as ConsoleRole
  }
  if (values.activity === "signed-in" || values.activity === "never") {
    q.activity = values.activity
  }
  return q
}

export function buildKeyFilterSchema(): FilterDef[] {
  return [
    {
      id: "origin",
      label: "Origin",
      kind: "select",
      options: [
        { value: "user", label: "Created here" },
        { value: "env", label: "From env" },
      ],
      placeholder: "Any origin",
    },
    {
      id: "activity",
      label: "Activity",
      kind: "select",
      options: [
        { value: "used", label: "Has been used" },
        { value: "never", label: "Never used" },
      ],
      placeholder: "Any",
    },
  ]
}

export function keyFiltersToQuery(values: FilterValues): KeyFilters {
  const q: KeyFilters = {}
  if (values.origin === "user" || values.origin === "env") q.origin = values.origin
  if (values.activity === "used" || values.activity === "never") q.activity = values.activity
  return q
}
